import { MutableRefObject } from 'react'
import * as API from 'api'
import { Dashboard } from 'schemas/DashboardSchema'
import DashboardPDFFormat, { DashboardPDFFormatStrings } from 'enums/DashboardPDFFormat'
import { Page } from 'features/ui/types'
import * as liveReportServiceAPI from 'liveReportService'
import SunburstChartPatcher from './patcher/SunburstChartPatcher'
import StrechTablePatcher from './patcher/StrechTablePatcher'
import { getClonedHead, getClonedBody } from './htmlExtractor'

const A4_RATIO = 21 / 29.7

const resolvePageHeight = (pdfFormat: DashboardPDFFormatStrings, dashboardWidth: number) => {
  switch (pdfFormat) {
    case DashboardPDFFormat.LANDSCAPE:
      return Math.floor(dashboardWidth * A4_RATIO)
    case DashboardPDFFormat.PORTRAIT:
      return Math.floor(dashboardWidth / A4_RATIO)
    default:
      return undefined
  }
}

const urlEncode = (input: string) =>
  encodeURIComponent(input)
    .replace(/%20/g, ' ')
    .replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`)

const htmlEscape = (input: string) =>
  input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

const htmlEscapeWithEntityNumber = (input: string) => {
  let esacpeContent = htmlEscape(input)
  esacpeContent = esacpeContent.replace(
    /[\u007f-\uffff]/g,
    (character: string) => `&#${character.charCodeAt(0)};`
  )

  return esacpeContent
}

const exportPdf = async (
  dashboardData: Dashboard,
  dashboardRef: MutableRefObject<HTMLDivElement>,
  refObjectToHide: MutableRefObject<HTMLDivElement>[],
  page?: Page
) => {
  const { pdfFormat, name } = dashboardData
  const dashboardWidth = dashboardRef.current.offsetWidth
  const pageHeight = resolvePageHeight(pdfFormat!, dashboardWidth)

  const clonedHead = getClonedHead()
  const clonedBody = getClonedBody(refObjectToHide, [
    new SunburstChartPatcher(),
    new StrechTablePatcher()
  ])

  const htmlCode = `<html>${clonedHead.outerHTML}${clonedBody.outerHTML}</html>`

  // handle dynamic API
  const dynamicAPI = page === Page.LiveReport ? liveReportServiceAPI : API
  await dynamicAPI.exportPdf(
    urlEncode(htmlEscapeWithEntityNumber(htmlCode)),
    name!,
    window.innerWidth,
    window.innerHeight,
    pageHeight
  )
}

export default exportPdf
